// extracted by mini-css-extract-plugin
export default {"main":"DownloadAppPage_main__RRm7G"};